"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HintIcon = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = require("styled-components");
exports.HintIcon = (0, react_1.forwardRef)((_a, ref) => {
    var { isError } = _a, props = __rest(_a, ["isError"]);
    const theme = (0, styled_components_1.useTheme)();
    return (react_1.default.createElement("svg", Object.assign({}, props, { ref: ref, width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }),
        react_1.default.createElement("circle", { cx: "11", cy: "11", r: "10" }),
        react_1.default.createElement("path", { d: "M10.1429 5.85709C10.1429 5.3837 10.5266 4.99995 11 4.99995C11.4734 4.99995 11.8571 5.3837 11.8571 5.85709V6.71423C11.8571 7.18762 11.4734 7.57138 11 7.57138C10.5266 7.57138 10.1429 7.18762 10.1429 6.71423V5.85709Z", fill: isError ? theme.colors.icon.error : theme.colors.icon.primary }),
        react_1.default.createElement("path", { d: "M11 9.28566C10.5266 9.28566 10.1429 9.66942 10.1429 10.1428V16.1428C10.1429 16.6162 10.5266 16.9999 11 16.9999C11.4734 16.9999 11.8571 16.6162 11.8571 16.1428V10.1428C11.8571 9.66942 11.4734 9.28566 11 9.28566Z", fill: isError ? theme.colors.icon.error : theme.colors.icon.primary }),
        react_1.default.createElement("path", { "data-border-circle": true, fillRule: "evenodd", clipRule: "evenodd", d: "M11 21.2857C16.6806 21.2857 21.2857 16.6806 21.2857 10.9999C21.2857 5.3193 16.6806 0.714233 11 0.714233C5.31936 0.714233 0.714287 5.3193 0.714287 10.9999C0.714287 16.6806 5.31936 21.2857 11 21.2857ZM11 19.5714C15.7339 19.5714 19.5714 15.7338 19.5714 10.9999C19.5714 6.26608 15.7339 2.42852 11 2.42852C6.26613 2.42852 2.42857 6.26608 2.42857 10.9999C2.42857 15.7338 6.26613 19.5714 11 19.5714Z", fill: isError ? theme.colors.icon.error : theme.colors.icon.primary })));
});
